import { useMemo } from 'react';
import { format } from 'components/atoms/input-duration';
import { ProjectTemplateApi } from 'data/templates/projects';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import {
  anyTemplateHasBudgetedHoursConfig,
  getBudgetedHoursFromTemplates,
} from './utils';

export const useBudgetedHoursFromTemplates = ({
  templates,
}: {
  templates: ProjectTemplateApi[];
}): {
  isBudgetedHoursConfiguredForAnyTemplate: boolean;
  estimatedBudgetedHours: string;
  maximumPossibleBudgetedHours: number;
} => {
  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );
  const isBudgetedHoursConfiguredForAnyTemplate = useMemo(
    () => anyTemplateHasBudgetedHoursConfig(templates),
    [templates],
  );
  const { minimumPossibleBudgetedHours, maximumPossibleBudgetedHours } =
    useMemo(
      () =>
        isTimesheetFeatureEnabled
          ? getBudgetedHoursFromTemplates(templates)
          : {
              minimumPossibleBudgetedHours: 0,
              maximumPossibleBudgetedHours: 0,
            },
      [isTimesheetFeatureEnabled, templates],
    );
  const estimatedBudgetedHours =
    minimumPossibleBudgetedHours === maximumPossibleBudgetedHours
      ? format('hh', maximumPossibleBudgetedHours)
      : `${format('hh', minimumPossibleBudgetedHours)} - ${format(
          'hh',
          maximumPossibleBudgetedHours,
        )}`;

  return {
    isBudgetedHoursConfiguredForAnyTemplate,
    maximumPossibleBudgetedHours,
    estimatedBudgetedHours,
  };
};
